import {
  createFileRoute,
  redirect,
  isRedirect,
} from '@tanstack/react-router'
import { getAccessToken, hasAccessToken } from '@/lib/token-storage'
import { getUserProfile } from '@/api/workspace/profile.actions'
import { userRequiresPhoneVerification } from '@/lib/phone-verification-gate'
import { loginRedirectSearchSchema } from '@/lib/login-redirect-search'
import { completeLoginWithTokens } from '@/lib/complete-login-with-tokens'
import CompletarCelularPage from '@/pages/auth/completar-celular-page'

export const Route = createFileRoute('/completar-celular')({
  validateSearch: loginRedirectSearchSchema,
  beforeLoad: async ({ search }) => {
    if (!hasAccessToken()) {
      throw redirect({ to: '/', search })
    }

    try {
      const profile = await getUserProfile()
      if (
        !userRequiresPhoneVerification(
          profile.data.celular,
          profile.data.celularConfirmado,
        )
      ) {
        const accessToken = getAccessToken()
        if (!accessToken) {
          throw redirect({ to: '/', search })
        }
        await completeLoginWithTokens(
          { accessToken },
          {
            returnApp: search.return_app,
            next: search.next,
          },
        )
        return
      }
    } catch (error) {
      if (isRedirect(error)) {
        throw error
      }
      // Mantém a tela de completar celular se o token existe, mesmo com
      // falha transitória no perfil — evita bounce para o login após magic link.
    }
  },
  component: CompletarCelularPage,
})
